import { useSupportedVersionWarning } from '../hooks/use-supported-version-warning';

const UnsupportedVersionCheck: React.FC = () => {
  useSupportedVersionWarning();

  return null;
};

export default UnsupportedVersionCheck;
